import React from 'react';
import AppLayout from '../../layouts/AppLayout';
import EditImageWorkspace from './components/EditImageWorkspace';
import useEditImageDomain from './hooks/useEditImageDomain';
import './styles.css';

function EditImagePage() {
  const state = useEditImageDomain();

  return (
    <AppLayout
      title="Editar Imagem"
      subtitle="Edição guiada por IA"
      fullWidth
    >
      <EditImageWorkspace state={state} />
    </AppLayout>
  );
}

export default EditImagePage;
